import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useStore } from '@nanostores/vue'
import { setSearchValue } from '@/store/searchInput'
import { pageName } from '@/store/pageName'
import { getSiteBaseUrl } from '@/lib/siteBaseUrl'
import { useBreakpoints } from '@/lib/utils'

const isGlobalPageName = useStore(pageName)

export function usePCSSearchInput() {
	const isProduction = import.meta.env.PROD
	const isProductionURL = isProduction ? '/shop/search' : '/search'

	const { isLarge } = useBreakpoints()
	const inputValue = ref('')

	const isInputNotEmpty = computed(() => inputValue.value.trim().length > 0)

	const pageDisplayMapping = {
		home: { mobile: true, desktop: false },
		default: { mobile: true, desktop: true },
	}

	const shouldShowComponent = computed(() => {
		const deviceType = isLarge ? 'desktop' : 'mobile'
		if (isGlobalPageName.value === 'home') {
			return pageDisplayMapping.home[deviceType]
		}
		return pageDisplayMapping.default[deviceType]
	})

	const navigateToSearch = (): void => {
		const trimmedInput = inputValue.value.trim()
		const buyandshipBaseUrl = import.meta.env.PROD
			? getSiteBaseUrl()
			: window.location.origin

		if (trimmedInput) {
			setSearchValue(trimmedInput)
			const searchURL = new URL(buyandshipBaseUrl + isProductionURL)
			searchURL.searchParams.set('q', trimmedInput)
			window.location.href = searchURL.href
		}
	}

	const clearInputValue = (): void => {
		inputValue.value = ''
	}

	onMounted(() => {
		window.addEventListener('popstate', clearInputValue)
	})

	onUnmounted(() => {
		window.removeEventListener('popstate', clearInputValue)
	})

	return {
		inputValue,
		shouldShowComponent,
		isInputNotEmpty,
		navigateToSearch,
		clearInputValue,
	}
}
